module.exports = __webpack_public_path__ + "static/media/YELLOW-DISC_01.987096aa.png";